import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.css"],
})
export class CategoryComponent implements OnInit {
  shimmerStatus = {
    category: true,
  };
  data: any;
  isLoding = true;
  apiParam = { slug: "", limit: 20, offset: 0, feature: false, banner: false };
  subcategory = [];
  investiLanguage: any;
  loadMore = false;
  initStatus: boolean;
  viewMore = true;
  show = true;
  watchingData = false;
  homeData;
  featuredData: any = [];
  @ViewChild("panel", { read: ElementRef }) public panel: ElementRef<any>;

  constructor(
    public service: BaseService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.service.listStatus = true;
    window.scrollTo(0, 0);
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.investiLanguage = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
      this.translate.use(this.investiLanguage);
    }

    // this.translate.onLangChange.subscribe((e: any) => {
    //   this.titleService.setTitle(e.translations.PAGE_TITLE);
    // });
    this.initStatus = true;
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
        this.service.playerReady = false;
        this.service.modelData = undefined;
      } else {
        this.service.playerReady = false;
        this.service.modelData = undefined;
      }

      this.getData("");
      if (localStorage.getItem(environment.localStorageKey)) {
        this.watchingData = true;
      }
    });
  }

  watching: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 2,
      },
      380: {
        items: 2,
      },
      450: {
        items: 2,
      },
      650: {
        items: 3,
      },
      910: {
        items: 4,
      },
      1108: {
        items: 4,
      },
      1230: {
        items: 4,
      },
      1400: {
        items: 5,
      },
    },
    nav: true,
  };

  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }

  getData(from) {
    const localdata = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    let index = -1;
    if (localdata) {
      index = localdata
        .map((el) => {
          return el.hasOwnProperty(this.apiParam.slug);
        })
        .indexOf(true);
    }

    if (localdata && index != -1) {
      this.data = localdata[index][this.apiParam.slug];
      if (this.data.featured.length > 0) {
        this.isLoding = false;
        this.featuredData = this.data;
      } else {
        this.isLoding = false;
      }
      this.homeData = localdata[index][this.apiParam.slug];
      this.subcategory = localdata[index][this.apiParam.slug].subcategory;
      this.shimmerStatus.category = false;
    } else {
      this.moreData(from);
    }
  }
  moreData(from) {
    if (this.initStatus) {
      let localdata = JSON.parse(
        localStorage.getItem(environment.pagesLocalStorageKey)
      );
      if (!localdata) {
        localdata = [];
      }
      const index = localdata.findIndex((values) => values[this.apiParam.slug]);

      this.service.categoryData(this.apiParam).subscribe(
        (data: any) => {
          this.data = data;
          if (this.data.featured.length > 0) {
            this.isLoding = false;
            this.featuredData = this.data;
          } else {
            this.isLoding = false;
          }
          if (from === "") {
            this.subcategory = [];
          }
          if (this.data.subcategory.length > 0) {
            this.subcategory = this.subcategory.concat(this.data.subcategory);
            this.loadMore = false;
            this.show = true;
            this.shimmerStatus.category = false;
            if (index != -1) {
              localdata[index][this.apiParam.slug].subcategory = localdata[
                index
              ][this.apiParam.slug].subcategory.concat(this.data.subcategory);
            } else {
              localdata.push({ [this.apiParam.slug]: this.data });
            }
            localStorage.setItem(
              environment.pagesLocalStorageKey,
              JSON.stringify(localdata)
            );
          } else {
            this.shimmerStatus.category = false;
            this.loadMore = false;
            this.show = false;
          }
        },
        (err) => {
          if (err) {
            setTimeout(() => {
              this.shimmerStatus.category = false;
              this.loadMore = false;
              this.isLoding = false;
            }, 3000);
          }
        }
      );
    }
  }

  viewMoreData() {
    this.loadMore = true;
    this.show = false;
    if (this.data.subcategory.length > 0 && this.loadMore === true) {
      this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
      this.moreData("pagination");
    }
  }
}
